import React from 'react';

const SIZE_CLASS = {
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
};

const VARIANT_CLASS = {
  brand: { a: 'text-[#001E7A]', wise: 'text-[#0290F5]' },
  onDark: { a: 'text-white', wise: 'text-sky-200' },
};

interface AWiseWordmarkProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  size?: keyof typeof SIZE_CLASS;
  variant?: keyof typeof VARIANT_CLASS;
  as?: React.ElementType;
}

/**
 * Chat assistant wordmark: navy "A" + teal "Wise" (matches AgedCareWise logo colours).
 */
export default function AWiseWordmark({
  className = '',
  size = 'lg',
  variant = 'brand',
  as: Tag = 'span',
  ...rest
}: AWiseWordmarkProps) {
  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.lg;
  const colours = VARIANT_CLASS[variant] || VARIANT_CLASS.brand;
  return (
    <Tag className={`font-bold tracking-tight ${sizeClass} ${className}`.trim()} {...rest}>
      <span className={colours.a}>A</span>
      <span className={colours.wise}>Wise</span>
    </Tag>
  );
}
